import PortfolioModel from 'models/PortfolioModel'

export default class PortfolioCollection extends Backbone.Collection {

    saveNewSequence(ids) {
        for (const [sequence, id] of ids.entries()) {
            this.get(id).set('sequence', sequence);
        }

        this.sort();

        $.post('/portfolio/update_sequence', { sequence: ids });

        this.trigger('sequenceChanged');
    }

    preinitialize() {
        this.constructor.type = 'portfolios'
    }

    get model() {
        return PortfolioModel
    }

    initialize(models, userId) {
        this.userId = userId
    }

    url() {
        return `/portfolio/home/${this.userId}.json`
    }

    parse(response) {
        return response.projects
    }

}
